var _excluded = ["size", "variant", "emphasis", "children", "htmlTag", "icon", "wrapLabel", "borderRadius"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import { IconWrapper, StyledLabelAtm } from "./LabelAtm.styles";
export var defaultProps = {
  size: "default",
  variant: "default",
  borderRadius: "medium"
};
function LabelAtm(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaultProps.size : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? defaultProps.variant : _ref$variant,
    emphasis = _ref.emphasis,
    children = _ref.children,
    htmlTag = _ref.htmlTag,
    icon = _ref.icon,
    wrapLabel = _ref.wrapLabel,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? defaultProps.borderRadius : _ref$borderRadius,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(StyledLabelAtm, _extends({
    as: htmlTag,
    $size: size,
    $variant: variant,
    $onColor: onColor,
    $emphasis: emphasis,
    $hasIcon: !!icon,
    $wrapLabel: wrapLabel,
    $borderRadius: borderRadius
  }, restProps), icon ? /*#__PURE__*/React.createElement(IconWrapper, null, icon) : undefined, children);
}
export default LabelAtm;